
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/--mobile/download",
      function () {
        return require("private-next-pages/--mobile/download/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/--mobile/download"])
      });
    }
  